import { guideConstants } from "../../constants"
import { guideService } from "../../../services/api.guides"
import { notify } from 'reapop'

export const organizationActions = {
    getAll,
    getById,
    create,
    update,
    archive,
    delete: _delete
};


function getAll(params) {
    return (dispatch) => {
        dispatch(request());

        guideService.getAllOrginizations(params).then(
            (response) => dispatch(success(response)),
            (error) => {
                dispatch(failure(error.message));
                dispatch(notify({ title: "Ошибка при получении списка организаций", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request() {
        return { type: guideConstants.GETALL_REQUEST_ORGANIZATIONS };
    }
    function success(response) {
        return { type: guideConstants.GETALL_SUCCESS_ORGANIZATIONS, response };
    }
    function failure(error) {
        return { type: guideConstants.GETALL_FAILURE_ORGANIZATIONS, error };
    }
}

function getById(id) {
    return (dispatch) => {
        dispatch(request(id));

        guideService.getOrginizationById(id).then(
            (response) => {
                dispatch(success(response));
            },
            (error) => {
                dispatch(failure(error.message));
                dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request(id) {
        return { type: guideConstants.GETBYID_REQUEST_ORGANIZATIONS, id };
    }
    function success(response) {
        return { type: guideConstants.GETBYID_SUCCESS_ORGANIZATIONS, response };
    }
    function failure(error) {
        return { type: guideConstants.GETBYID_FAILURE_ORGANIZATIONS, error };
    }
}

function create(params) {
    return (dispatch) => {
      console.log('Params in create:', params); // Добавьте этот лог
        dispatch(request(params));

        guideService.createOrginization(params).then(
            (response) => {
                dispatch(success(response.result));
                dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
            },
            (error) => {
                dispatch(failure(error.message));
                dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request(response) {
        return { type: guideConstants.CREATE_REQUEST_ORGANIZATIONS, response };
    }
    function success(response) {
        return { type: guideConstants.CREATE_SUCCESS_ORGANIZATIONS, response };
    }
    function failure(error) {
        return { type: guideConstants.CREATE_FAILURE_ORGANIZATIONS, error };
    }
}

function update(id, params) {
    return (dispatch) => {
        dispatch(request(id));

        guideService.updateOrginization(id, params).then(
            (response) => {
                dispatch(success(response.result));
                dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
            },
            (error) => {
                dispatch(failure(error.message));
                dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request(id) {
        return { type: guideConstants.UPDATE_REQUEST_ORGANIZATIONS, id };
    }
    function success(response) {
        return { type: guideConstants.UPDATE_SUCCESS_ORGANIZATIONS, response };
    }
    function failure(error) {
        return { type: guideConstants.UPDATE_FAILURE_ORGANIZATIONS, error };
    }
}

function archive(id) {
    return (dispatch) => {
        dispatch(request(id));

        guideService.archiveOrganization(id).then(
            (response) => {
                dispatch(success(id));
                dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
            },
            (error) => {
                dispatch(failure(error.message));
                dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request(id) {
        return { type: guideConstants.ARCHIVE_REQUEST_ORGANIZATIONS, id };
    }
    function success(id) {
        return { type: guideConstants.ARCHIVE_SUCCESS_ORGANIZATIONS, id };
    }
    function failure(error) {
        return { type: guideConstants.ARCHIVE_FAILURE_ORGANIZATIONS, error };
    }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return (dispatch) => {
        dispatch(request(id));

        guideService.deleteOrginization(id).then(
            (response) => {
                dispatch(success(id));
                dispatch(notify({ title: "Успешно", message: response.message, status: 'success', image: "/public/assets/images/illustrations/check.svg" }));
            },
            (error) => {
                dispatch(failure(id, error.message));
                dispatch(notify({ title: "Ошибка", message: error.message, status: 'error', image: "/public/assets/images/illustrations/close.svg" }))
            }
        );
    };

    function request(id) {
        return { type: guideConstants.DELETE_REQUEST_ORGANIZATIONS, id };
    }
    function success(id) {
        return { type: guideConstants.DELETE_SUCCESS_ORGANIZATIONS, id };
    }
    function failure(id, error) {
        return { type: guideConstants.DELETE_FAILURE_ORGANIZATIONS, id, error };
    }
}
